import { render, staticRenderFns } from "./RefAutocomplete2.vue?vue&type=template&id=67c150d1&"
import script from "./RefAutocomplete2.vue?vue&type=script&lang=js&"
export * from "./RefAutocomplete2.vue?vue&type=script&lang=js&"
import style0 from "./RefAutocomplete2.vue?vue&type=style&index=0&id=67c150d1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports